﻿import { SET_LUTDATA, SetLutDataAction } from './Types';
import { LutData } from '../../Utilities/LutApi';

export function setLutData(lutData: LutData): SetLutDataAction {
    return {
        type: SET_LUTDATA,
        payload: lutData,
    };
}
